import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { TenantConstant } from '@app-constants/tenant.constant';
import { LoginService } from '@app-services/login/login.service';
import { RestApiService } from '@app-services/rest/rest-api.service';
import * as moment from 'moment';
import { LocalStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import {SubscriptionService} from '@app-services/subscription/subscription.service';
import { ClassService } from 'src/app/core/services/class.service';
import { apisDataCacheKeys, examDisplayNames, gradeField, testCLassesMap, curTenantDetails, PaidSubscribedTest, timeBoundTypes, nonTimeBoundTypes } from '@app-constants/app.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { filterCMSData, getCourseId, getCourseName, getExamName, isUserAdmin } from '@app-helpers/functions';
import { UserService } from '@app-services/user/user.service';
import {  map, share, switchMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TestlistService extends RestApiService{

  apiUrl = ApiUrlConstant.examUrl;
  cmsapiUrl = ApiUrlConstant.cmsrUrl;
  cyotUrl = ApiUrlConstant.cyotUrl;
  newApiUrl = ApiUrlConstant.newApiUrl;
  uamApiUrl = ApiUrlConstant.apiUrl;
  tenant: any = TenantConstant.tenant;
  portal: any = TenantConstant.portal;
  omsdevapi:string =ApiUrlConstant.omsdevapi;
  stageeosapi:string =ApiUrlConstant.stageeosapi;

  LEARN_BE_EVENT_API:string =ApiUrlConstant.LEARN_BE_EVENT_API;
  refreshTestData = new BehaviorSubject<boolean>(false);
  testDataRefresh = this.refreshTestData.asObservable();
  scoreRegafterPayment = new BehaviorSubject<boolean>(false);
  scoreRegafterPayment$ = this.scoreRegafterPayment.asObservable()
  attemptExamInfo:any = {};
  filterCMSData = filterCMSData;
  examAttempedbysubId:any = [];
  redis_save_question_payload :any = {};
  examNameChange = new BehaviorSubject<any>('')
  examNameChange$ = this.examNameChange.asObservable();
  public getUSerExamlist:any = null;
  public selectedReportPaper:string = '';
  public cardsV2List:any =[]
  constructor(http: HttpClient, storage: LocalStorageService, gaService: GAnalyticsService, private loginService: LoginService,public router:Router,public SubscriptionService :SubscriptionService, public classService: ClassService,public spinner:NgxSpinnerService,
   public userService:UserService) { super(http, storage, gaService);
    var user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    this.subscriptionData.userDetails = user;
    this.subscriptionData.userDetails.gradenumber = user?.grade?.name?.replace(/[^0-9]/g,'');
    console.log('this.subscriptionData.userDetails: ', this.subscriptionData.userDetails);
  }
  @Output() examNameChanged: EventEmitter<any> = new EventEmitter();
  @Output() toLCFromASM: EventEmitter<any> = new EventEmitter();

  getExamInfoBoxes(): Observable<any>{
    let examName = localStorage.getItem("targetExamName") as string;
    // if(!examName) {
    //   examName = "NEET"
    // }
    let x = [

      {
        logo: 'assets/img/ilts.svg',
        heading: "Final Infinity National Learners Exam (FINALE)",
        examname: examName,
        examtype: 'GRANDTEST',
        examtypeIntended: 'GRANDTEST',
        shortname: 'FINALE',//'Grand Tests',
        longname:"Final Infinity National Learners Exam (FINALE)",
        infoboxName: 'FINALE',//'Grand Test',
        trPrimary:  'FINALE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Practice for your exams with live papers along with other students',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=GRANDTEST`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          // 'NEET': 2,
          // "JEEMAIN": 2,
          // "JEEADVANCED": 2,
        }
      },
      {
        logo: 'assets/img/scorelogo.svg',
        heading: 'SCORE',//'Infinity Learn India Talent Exam (ILITE)',
        examname: examName,
        examtype: 'SCHOLARSHIPTEST',
        examtypeIntended: 'SCHOLARSHIPTEST',
        shortname: 'ILITE',
        longname:'Infinity Learn India Talent Exam (ILITE)',
        infoboxName: 'SCORE',
        trPrimary:  'ILITE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Participate in India’s no. 1 scholarship exam and get a chance to win scholarships and prizes',
        link: {
          label: 'OPEN LIST',
          // route: `/dashboard/testlist?examname=${examName}&examtype=SCHOLARSHIPTEST`
          route: `/dashboard/testlist/score?examname=${examName}&examtype=SCHOLARSHIPTEST`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': this.tenant == 'infinitylearn' && 1,
          "JEEMAIN": this.tenant == 'infinitylearn' && 1,
          "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
          "APTITUDETEST": 1,
          "FOUNDATIONTEST": 1
        }
      },
      {
        logo: 'assets/img/ilts.svg',
        heading: (this.tenant=='srichaitanya')? 'Sri Chaitanya Test Series (SCTS)' : 'ILTS (Infinity Learn Test Series) ',
        examname: examName,
        examtype: 'New NEET Timebound',
        examtypeIntended: 'TIMEBOUND',
        shortname: (this.tenant=='srichaitanya')?'SCTS':'ILTS',
        longname:(this.tenant=='srichaitanya')?'Sri Chaitanya Test Series':'Infinity Learn Test Series',
        infoboxName: (this.tenant=='srichaitanya')?'SCTS':'ILTS',
        trPrimary:  (this.tenant=='srichaitanya')?'SCTS':'ILTS',
        trSecondary:  (this.tenant=='srichaitanya')?'Sri Chaitanya Test Series':'Infinity Learn Test Series',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Practice for your exams with live papers along with other students',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=New%20NEET%20Timebound`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': 3,
          'CBSE':4
        }
      },
      {
        logo: 'assets/img/tests-icons.svg',
        heading: `Mock Tests (MCT's)`,
        examname: examName,
        examtype: 'New NEET Mock Test',
        examtypeIntended: 'MOCKTEST',
        shortname: 'MCTs',
        infoboxName: 'MCT',
        longname:'Mock Tests',
        trPrimary:  'MCTs',
        trSecondary:  ' (Mock Tests)',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'We\’ve curated mock tests to help you reach your best potential for the exam',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=New%20NEET%20Mock%20Test`
        },
        rankAndPercentile: null,
        testLists: [],
        exams: {
          'NEET': 4,
          'CBSE':3
        }
      },
      {
        logo: 'assets/img/peper-icon.svg',
        heading: `Previous Year Papers (PYP's)`,
        examname: examName,
        examtype: 'PREVIOUSYEAR',
        examtypeIntended: 'PREVIOUSYEAR',
        shortname: 'PYP',
        longname:'Previous Year Papers',
        infoboxName: 'PYP',
        trPrimary:  'PYPs',
        trSecondary:  ' (Previous Year Papers)',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: `Practice the previous year papers from 2013 and be ready for your ${examDisplayNames[examName]} exam`,
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=PREVIOUSYEAR`
        },
        rankAndPercentile: null,
        testLists: [],
        exams: {
          'NEET': 5,
          "JEEMAIN": 5,
          "JEEADVANCED": 5,
        }
      },
      {
        logo: 'assets/img/ilts.svg',
        heading: (this.tenant=='srichaitanya')? (examName == 'SCORE' ? 'Sri Chaitanya Outstanding Achiever Reward Examination (SCORE)' : examName == 'SCAT'? 'Sri Chaitanya Admission-cum-scholarship Test (SCAT)': 'Sri Chaitanya Test Series (SCTS)'): examName == 'CBSE'  ?'All India CBSE Board Test Series' :'ILTS (Infinity Learn Test Series )',
        examname: examName,
        examtype: 'TIMEBOUND',
        examtypeIntended: 'TIMEBOUND',
        shortname: (this.tenant=='srichaitanya')? (this.portal == 'SCORE' ?  examName :'SCTS'):'ILTS',
        longname:(this.tenant=='srichaitanya')? (examName == 'SCORE' ? 'Sri Chaitanya Outstanding Achiever Reward Examination' : examName =='SCAT'? 'Sri Chaitanya Admission-cum-scholarship Test': 'Sri Chaitanya Test Series'):'Infinity Learn Test Series',
        infoboxName: (this.tenant=='srichaitanya')? (this.portal == 'SCORE' ?  examName :'SCTS'):'ILTS',
        trPrimary:  (this.tenant=='srichaitanya')? (this.portal == 'SCORE' ?  examName :'SCTS'):'ILTS',
        trSecondary:  (this.tenant=='srichaitanya')? (examName == 'SCORE' ? '(Sri Chaitanya Outstanding Achiever Reward Examination)' : examName =='SCAT'? '(Sri Chaitanya Admission-cum-scholarship Test)': '(Sri Chaitanya Test Series)'):'(Infinity Learn Test Series)',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: this.portal == 'SCORE' ? "North India's Biggest Talent Hunt Exam": 'Practice for your exams with live papers along with other students',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=TIMEBOUND`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          //'NEET': 6,
          "JEEMAIN": 3,
          "JEEADVANCED": 3,
          "SCORE": 1,
          "SCAT": 1,
          "CBSE":2
        }
      },
      {
        logo: 'assets/img/tests-icons.svg',
        heading: this.portal == 'SCORE' ? `${examName} Mock Tests(MCT's)`: `Mock Tests (MCT's)`,
        examname: examName,
        examtype: 'MOCKTEST',
        examtypeIntended: 'MOCKTEST',
        shortname: this.portal == 'SCORE' ? 'MCTs' : 'MCTs',
        longname: this.portal == 'SCORE' ? `${examName} Mock Tests`: 'Mock Tests',
        infoboxName: this.portal == 'SCORE' ? 'MCT' : 'MCT',
        trPrimary: this.portal == 'SCORE' ? `${examName} MCTs` : 'MCTs',
        trSecondary:  ' (Mock Tests)',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'We\’ve curated mock tests to help you reach your best potential for the exam',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=MOCKTEST`
        },
        rankAndPercentile: null,
        testLists: [],
        exams: {
        //  'NEET': 7,
          "JEEMAIN": 4,
          "JEEADVANCED": 4,
          "SCORE": 2,
          "SCAT": 2,
          "NTSE": 1,
          "CBSE":3
        }
      },
      {
        logo: 'assets/img/scorelogo.svg',
        heading: 'SCORE',//'Infinity Learn India Talent Exam (ILITE)',
        examname: examName,
        examtype: 'SCOREMOCKTEST',
        examtypeIntended: 'SCOREMOCKTEST',
        shortname: 'ILITE',
        longname:'Infinity Learn India Talent Exam (ILITE)',
        infoboxName: 'SCORE',
        trPrimary:  'ILITE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Participate in India’s no. 1 scholarship exam and get a chance to win scholarships and prizes',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=SCOREMOCKTEST`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': this.tenant == 'infinitylearn' && 1,
          "JEEMAIN": this.tenant == 'infinitylearn' && 1,
          "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
          "APTITUDETEST": 1,
          "FOUNDATIONTEST": 1
        }
      },
      {
        logo: 'assets/img/scorelogo.svg',
        heading: 'Create your own Test',//'Infinity Learn India Talent Exam (ILITE)',
        examname: examName,
        examtype: 'CYOT',
        examtypeIntended: 'CYOT',
        shortname: 'ILITE',
        longname:'Create your own test.',
        infoboxName: 'CYOT',
        trPrimary:  'ILITE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: '',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=CYOT`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': this.tenant == 'infinitylearn' && 1,
          "JEEMAIN": this.tenant == 'infinitylearn' && 1,
          "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
          "APTITUDETEST": 1,
          "FOUNDATIONTEST": 1
        }
      },
      {
        logo: 'assets/img/scorelogo.svg',
        heading: (examName == "JEEMAIN" ? "Rapid Revision Ranker Test Series (RRRTS)" : 'Rank Assurance Program Test Series (RAPTS)'),//'Infinity Learn India Talent Exam (ILITE)',
        examname: examName,
        examtype: examName == "JEEMAIN" ?'b9f32e18-34e8-11ed-a261-0242ac120002' :'RAPTimeBound',
        examtypeIntended:examName == "JEEMAIN" ?'b9f32e18-34e8-11ed-a261-0242ac120002' : 'RAPTimeBound',
        shortname: 'RAPTS',
        longname:'Infinity Learn India Talent Exam (ILITE)',
        infoboxName:examName == "JEEMAIN" ? 'RRRTS':'RAPTS',
        trPrimary:  'ILITE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Rank Assurance Program Daily Tests (RAPDT) helps you practice daily with a simulated test environment to improve your speed and accuracy and improve learning outcomes to ace the final test.',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=${examName == "JEEMAIN" ?'b9f32e18-34e8-11ed-a261-0242ac120002' :'RAPTimeBound'}`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': this.tenant == 'infinitylearn' && 1,
          "JEEMAIN": this.tenant == 'infinitylearn' && 1,
          "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
          "APTITUDETEST": 1,
          "FOUNDATIONTEST": 1
        }
      },
      {
        logo: 'assets/img/scorelogo.svg',
        heading: (examName == "JEEMAIN" ? 'Rapid Revision Ranker Daily Tests (RRRDT)': 'Rank Assurance Program Daily Tests (RAPDT)'),//'Infinity Learn India Talent Exam (ILITE)',
        examname: examName,
        examtype: examName == "JEEMAIN" ? 'cf03ca38-34e8-11ed-a261-0242ac120002': 'RAPDailyTest',
        examtypeIntended: examName == "JEEMAIN" ? 'cf03ca38-34e8-11ed-a261-0242ac120002': 'RAPDailyTest',
        shortname: 'ILITE',
        longname:'Rank Assurance Program Daily Tests (RAPDT)',
        infoboxName:examName == "JEEMAIN" ?'RRRDT' : 'RAPDT',
        trPrimary:  'ILITE',
        trSecondary:  '',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'Rank Assurance Program Daily Tests (RAPDT) helps you practice daily with a simulated test environment to improve your speed and accuracy and improve learning outcomes to ace the final test.',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=${ examName == "JEEMAIN" ? 'cf03ca38-34e8-11ed-a261-0242ac120002':'RAPDailyTest'}`
        },
        rankAndPercentile: {
          highestScore: 0,
          highestScoreOff: 0,
          highestRank: 0,
          highestRankOff: 0,
          highestPercentile:0
        },
        testLists: [],
        exams: {
          'NEET': this.tenant == 'infinitylearn' && 1,
          "JEEMAIN": this.tenant == 'infinitylearn' && 1,
          "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
          "APTITUDETEST": 1,
          "FOUNDATIONTEST": 1
        }
      },
      {
        logo: 'assets/img/tests-icons.svg',
        heading:  `Subjective Mock Test`,
        examname: examName,
        examtype: 'subjectivemocktest',
        examtypeIntended: 'subjectivemocktest',
        shortname:  'SMTs',
        longname:  'Mock Tests',
        infoboxName: 'SMT',
        trPrimary:'SMTs',
        trSecondary:  ' (Subjective Mock Tests)',
        paper: {
          totaltests: 0,
          completedtests: 0,
        },
        infotext: 'We\’ve curated mock tests to help you reach your best potential for the exam',
        link: {
          label: 'OPEN LIST',
          route: `/dashboard/testlist?examname=${examName}&examtype=subjectivemocktest`
        },
        rankAndPercentile: null,
        testLists: [],
        exams: {

        }
      },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Timebound Social",
            "examname": examName,
            "examtype": "0ed6411c-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "0ed6411c-65be-11ed-9022-0242ac120002",
            "shortname": "ILTS",
            "longname": "CUET Timebound Social",
            "infoboxName": "ILTS",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Timebound Social",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=0ed6411c-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Timebound Commerce",
            "examname": examName,
            "examtype": "1eda50ee-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "TIMEBOUND",
            "shortname": "ILTS",
            "longname": "CUET Timebound Commerce",
            "infoboxName": "ILTS",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Timebound Commerce",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=1eda50ee-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Mock tests - Science",
            "examname": examName,
            "examtype": "337edf2e-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "MOCKTEST",
            "shortname": "MCTs",
            "longname": "CUET Mock Test Science",
            "infoboxName": "MCT",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Mock tests - Science",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=337edf2e-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Mock tests - GT and English",
            "examname": examName,
            "examtype": "41d60246-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "MOCKTEST",
            "shortname": "MCTs",
            "longname": "CUET Mock tests - GT and English",
            "infoboxName": "MCT",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Mock tests - GT and English",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=41d60246-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Mock Test Social",
            "examname": examName,
            "examtype": "52d43478-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "MOCKTEST",
            "shortname": "MCTs",
            "longname": "CUET Mock Test Social",
            "infoboxName": "MCT",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Mock Test Social",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=52d43478-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Mock Test Commerce",
            "examname": examName,
            "examtype": "6649791e-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "MOCKTEST",
            "shortname": "MCTs",
            "longname": "CUET Mock Test Commerce",
            "infoboxName": "MCT",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Mock Test Commerce",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=6649791e-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET PYP Science",
            "examname": examName,
            "examtype": "71dd90e4-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "PREVIOUSYEAR",
            "shortname": "PYP",
            "longname": "CUET PYP Science",
            "infoboxName": "PYP",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET PYP Science",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=71dd90e4-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET PYP GT & English",
            "examname": examName,
            "examtype": "7dfddc62-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "PREVIOUSYEAR",
            "shortname": "PYP",
            "longname": "CUET PYP GT & English",
            "infoboxName": "PYPEnglish",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET PYP GT & English",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=7dfddc62-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET PYP Social",
            "examname": examName,
            "examtype": "a132a744-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "PREVIOUSYEAR",
            "shortname": "PYP",
            "longname": "CUET PYP Social",
            "infoboxName": "PYP",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET PYP Social",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=a132a744-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Infinity Learn Test Series (ILTS) - Science",
            "examname": examName,
            "examtype": "a851d6b8-65bd-11ed-9022-0242ac120002",
            "examtypeIntended": "TIMEBOUND",
            "shortname": "ILTS",
            "longname": "CUET Infinity Learn Test Series (ILTS) - Science",
            "infoboxName": "ILTS",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Infinity Learn Test Series (ILTS) - Science",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=a851d6b8-65bd-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET PYP Commerce",
            "examname": examName,
            "examtype": "afa94d8c-65be-11ed-9022-0242ac120002",
            "examtypeIntended": "PREVIOUSYEAR",
            "shortname": "PYP",
            "longname": "CUET PYP Commerce",
            "infoboxName": "PYP",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET PYP Commerce",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=afa94d8c-65be-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
            "logo": "assets/img/ilts.svg",
            "heading": "CUET Infinity Learn Test Series (ILTS) - GT and English",
            "examname": examName,
            "examtype": "d0e5c8fa-65bd-11ed-9022-0242ac120002",
            "examtypeIntended": "TIMEBOUND",
            "shortname": "ILTS",
            "longname": "CUET Infinity Learn Test Series (ILTS) - GT and English",
            "infoboxName": "ILTS",
            "trPrimary": "ILITE",
            "trSecondary": "",
            "paper": {
                "totaltests": 0,
                "completedtests": 0
            },
            "infotext": "CUET Infinity Learn Test Series (ILTS) - GT and English",
            "link": {
                "label": "OPEN LIST",
                "route": `/dashboard/testlist?examname=${examName}&examtype=d0e5c8fa-65bd-11ed-9022-0242ac120002`
            },
            "rankAndPercentile": {
                "highestScore": 0,
                "highestScoreOff": 0,
                "highestRank": 0,
                "highestRankOff": 0,
                "highestPercentile": 0
            },
            "testLists": [],
            "exams": {}
        },
        {
          logo: 'assets/img/cqbadge.svg',
          heading: "Compete Quotient Test",
          examname: examName,
          examtype: "53355d15-4a4a-4df8-a881-688c43f0c65e",
          examtypeIntended: "53355d15-4a4a-4df8-a881-688c43f0c65e",
          shortname: 'CQT',
          longname:"Compete Quotient Test (CQT)",
          infoboxName:'CQT',
          trPrimary:  'ILITE',
          trSecondary:  '',
          paper: {
            totaltests: 0,
            completedtests: 0,
          },
          infotext: 'Rank Assurance Program Daily Tests (RAPDT) helps you practice daily with a simulated test environment to improve your speed and accuracy and improve learning outcomes to ace the final test.',
          link: {
            label: 'OPEN LIST',
            route: `/dashboard/testlist/generaltest?examname=${examName}&examtype=53355d15-4a4a-4df8-a881-688c43f0c65e`
          },
          rankAndPercentile: {
            highestScore: 0,
            highestScoreOff: 0,
            highestRank: 0,
            highestRankOff: 0,
            highestPercentile:0
          },
          testLists: [],
          exams: {
            'NEET': this.tenant == 'infinitylearn' && 1,
            "JEEMAIN": this.tenant == 'infinitylearn' && 1,
            "JEEADVANCED": this.tenant == 'infinitylearn' && 1,
            "APTITUDETEST": 1,
            "FOUNDATIONTEST": 1
          }
        },

    ];
    return of(x);
  }

  changeExamName(name: any) {
    this.examNameChanged.emit(name);
  }

  getUserTestResponseData(body:any): Observable<any> {
    const url = this.newApiUrl + `exam/getUserResponseData`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, body, _headers);
  }
  getResponsesForMultipleExams(body:any): Observable<any> {
    // const url = this.newApiUrl + `getResponsesForMultipleExams`;
    const url = this.newApiUrl + `exam/userResponseDataForMultipleExams`;

    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, body, _headers);
  }
  storeUserTestResponseData(body:any): Observable<any> {
    const url = this.newApiUrl + `exam/userResponseData`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, body, _headers);
  }
  subscriptionData :any= {
    trialData :null,
    userDetails :{},
    subscriptionsList : null,
    totalcomponentsList :[]
  }
  apisData:any = {
    [apisDataCacheKeys.allTests]: null,
    [apisDataCacheKeys.atemptedTests]: null,
    [apisDataCacheKeys.allChapters]: null
  };

  apiEndpoints: any = {
    [apisDataCacheKeys.allTests]: 'getExamRules',
    [apisDataCacheKeys.atemptedTests]: 'getStudentAttemptedTests',
    [apisDataCacheKeys.allChapters]: 'getChaptersInfo'
  }

  multiSubscriber = (inp: any) => {
    let {method, itemUrl, _headers, itemKey, dataName, chapters = false, _body} = inp;
    let observers: any = [];
    return (observer: any) => {
      observers.push(observer);
      if (observers.length === 1) {
        //@ts-ignore
        const examsDetails = this.apisData[itemKey];
        if(examsDetails) {
          observers.forEach((o: any) => {
            o.next(examsDetails);
            o.complete();
          })
          observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
        } else {
          //const url = this.apiUrl + `validatestudenttoken`;
          const url = this.apiUrl + itemUrl;
          //+
          let obs: any;
          if(method == "GET") {
            obs = this.getWithHeaders<any>(url, _headers)
          } else {
            obs = this.getByHeaders<any>(url, _body,  _headers)
          }
          obs.subscribe((data: any) => {

              //@ts-ignore
              if(this.portal == 'SCORE' && (itemKey == apisDataCacheKeys.allTests || itemKey == apisDataCacheKeys.atemptedTests) && Array.isArray(data)) {
                let user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
                let grade = user[gradeField['user']] && user[gradeField['user']].name?.replaceAll(/[^0-9]/g, "");
                let userStream = grade == '11' && user?.stream?.name?.replaceAll(/[^a-z]/gi, "")?.toUpperCase()?.indexOf("NONMEDICAL") > -1 ? "NONMEDICAL": "MEDICAL";
                data = data.filter(d => {
                  if(/^SCORE_/i.test(d.coursetype)) {
                    const fieldName = gradeField[itemKey];
                    if(d[fieldName] && grade == d[fieldName].replaceAll(/[^0-9]/g, "")) {
                      if(grade == '11' && d.rulename) {
                        const dStream = d?.rulename?.replaceAll(/[^a-z]/gi, "")?.toUpperCase();
                        if(dStream?.indexOf(userStream) > -1) {
                          if(userStream == "MEDICAL") {
                            if(dStream.indexOf("NONMEDICAL") > -1) {
                              return false;
                            }
                          }
                        } else {
                          return false;
                        }
                      }
                      d.coursetypeOriginal = d.coursetype;
                      d.coursetype = 'SCORE';
                      return true;
                    }
                  }
                })
              }
              if(itemUrl =="rules/v2"){
                // changes as per new qb
                data.rules.forEach(element => {
                  if(element.exam_type != "undefined"){
                    const testTypeInfo = getExamName(element.test_type[0])
                    element.examtype = testTypeInfo;
                    if(Array.isArray(element.coursetype)){
                      element.coursetype = getCourseName(element.coursetype[0])
                    }else{
                      element.coursetype = getCourseName(element.coursetype)
                    }
                    element.className = element.className+'th';
                  }else{
                    element.examtype = 'PREVIOUSYEAR';
                    element.coursetype = 'NEET';
                    element.className = element.className+'th';
                  }
                });  //
                data = data?.rules;
              }
              if(itemUrl == "reports/studenttests"){
                data = data.data;
                data?.forEach(element => {
                  if(!element.exam_type){
                    element.exam_type = element.examtype;
                  }
                  element.coursetype=  getCourseName(element.examtype)
                })
              }
              this.apisData[itemKey] = data;
              observers.forEach((o: any) => {
                o.next(data);
                o.complete();
              })
              observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
              //@ts-ignore
              this[this.keyMap[itemKey]] = null;
            },
            (err: any) => {
              observers.forEach((o: any) => {
                observer.error(new Error("Issue in fetching details of "+ dataName))
              })
              observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
              if(err?.error?.message?.replaceAll(" ", "")?.toUpperCase().indexOf("ACCESSTOKENEXPIRED") > -1 || err?.error?.message?.replaceAll(" ", "")?.toUpperCase().indexOf("INVALIDTOKEN") > -1 ) {
                this.loginService.logoutEvent.emit({showPopup: true});
              }
            });
          }
        }
        return {unsubscribe() {
          //observers.splice(observers.indexOf(observer), 1);
        }
      };
    }
  }

  clearApisData = (key?: any) => {
    if (key) {
      this.apisData[key] = null;
    } else {
      this.apisData = {
        [apisDataCacheKeys.allTests]: null,
        [apisDataCacheKeys.atemptedTests]: null,
        [apisDataCacheKeys.allChapters]: null
      }
    }
  }

  keyMap = {
    [apisDataCacheKeys.allTests]: "allTestsDataObs",
    [apisDataCacheKeys.atemptedTests]: "attemptedTestsDataObs",
    [apisDataCacheKeys.allChapters]: "chaptersDataObs"
  }

  allTestsDataObsFactory = (_body?: any) => {
    let user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    let grade = user[gradeField['user']] && user[gradeField['user']].name;
    // let exams = user.exams.map(v=>v.name?.toUpperCase().replace(' ',''));
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    let cmsGradeIds = cmsDetails.map(e => e.CMS_grade_id);
    console.log(cmsDetails);
    console.log(cmsGradeIds);
    const _headers_for_Exam = {
      'accesstoken': localStorage.getItem('token')
      //'methodtype': 'RULES'
    };
    _body = _body ? _body :
      {
        // "classes": [String(grade)],
        // "coursetype": exams,
        // "userId": user?.userId
        "classes": cmsGradeIds,
        "exam_type": cmsExamIds
      }
      _body.studentid = localStorage.getItem('studentid')
      if(grade == "12th" ||grade == "13th"  ){//condition is for Rank Assurance program
        _body.classes.push('12th&13th')
      }
    return new Observable(this.multiSubscriber(
      {
        method: "POST", itemUrl: "rules/v2", _headers: _headers_for_Exam, itemKey: apisDataCacheKeys.allTests, dataName: "All Tests",
        _body
      }
    )
    );
  };

  allTestsDataObs: any;

  attemptedTestsDataObsFactory = () => {

    let _headers_for_Exam = {
      //'methodtype': 'GETTESTS',
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json'
    };

    let user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    let grade = user[gradeField['user']] && user[gradeField['user']].name;
    let _body_for_exam_result = {
      "studentid": localStorage.getItem('studentid'),
      // "studentClass": grade // commented bcoz of new qb API
    }
   if(grade == '13th' || grade == '12th'){
    // _body_for_exam_result.studentClass = grade+',12th&13th';//this is added to make RAPT exam class
   }  // commented bcoz of new qb API
    return new Observable(this.multiSubscriber(
      {
        method: "POST", itemUrl: "reports/studenttests", _headers: _headers_for_Exam, itemKey: apisDataCacheKeys.atemptedTests, dataName: "Attempted tests",
        _body: _body_for_exam_result
      }));
  };

  attemptedTestsDataObs: any;

  chaptersDataObsFactory = () => {

    let _headers_for_Exam = {
      //'methodtype': 'CHAPTER',
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json'
    };

    return new Observable(this.multiSubscriber(
      {
        method: "GET", itemUrl: 'getchapters', _headers: _headers_for_Exam, itemKey: apisDataCacheKeys.allChapters, dataName: "Chapters",
        _body: {'studentid': localStorage.getItem('studentid')}
      }));
  };

  chaptersDataObs: any;

  getChapters(): Observable<any> {
    if(!this.chaptersDataObs) {
      this.chaptersDataObs = this.chaptersDataObsFactory();
    }
    return this.chaptersDataObs;
  }

  getPreviousAndPresentMockTests(_body?: any): Observable<any>{
    if(!this.allTestsDataObs) {
      this.allTestsDataObs = this.allTestsDataObsFactory(_body);
    }
    return this.allTestsDataObs;
  }

  getStudentExamResult(): Observable<any>{
    if(!this.attemptedTestsDataObs) {
      this.attemptedTestsDataObs = this.attemptedTestsDataObsFactory();
    }
    return this.attemptedTestsDataObs;
  }

  getChapterTopics(chapterid: any) : Observable<any>{
    const url = this.apiUrl + `getchaptertopics`;
    const headers = {
      'accesstoken': localStorage.getItem('token'),
      //'methodtype': 'RULES'
    };
    return this.getByHeaders<any>(url, {chapterid}, headers);
  }

  getStudentTestRecord(ruleid: any, studentid: any) : Observable<any>{
    const url = this.newApiUrl + `reports/studenttestrecord`;
    const headers = {
      'accesstoken': localStorage.getItem('token'),
      //'methodtype': 'RULES'
    };
    return this.getByHeaders<any>(url, {ruleid, studentid, array: true}, headers);
  }

  updateRequestedAttemptedExamData(data: any) {
    this.apisData[apisDataCacheKeys.atemptedTests] = data;
  }

  getstudenthalltickets(body: any = {}) {
    const url = this.apiUrl + `registrations/getstudenthalltickets`;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      //'methodtype': 'RULES'
    };
    return this.getByHeaders<any>(url, body, _headers);
  }

  savestudenthalltickets(body: any = {}) {
    const url = this.apiUrl + `registrations/savestudenthalltickets`;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      //'methodtype': 'RULES'
    };
    return this.getByHeaders<any>(url, body, _headers);
  }

  saveToken(body_: any, _headers: any): Observable<any>{
    const url = this.apiUrl + `setaccesstoken `;
    //
    return this.getByHeaders<any>(url, {}, _headers);
  }
  getExamcards(){
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    // var user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    return this.getByHeaders(this.apiUrl + `exam/cards`,{grade: cmsDetails?.[0]?.CMS_grade_id,'coursetype':String(cmsExamIds[0])},_headers)
  }
getV2Cards(examsIds?){
  const _headers = {
    'accesstoken': localStorage.getItem('token'),
  };
  let cmsDetails = this.filterCMSData();
  let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
  return this.getByHeaders(this.apiUrl + `exam/getCards`,{"gradeId": cmsDetails?.[0]?.CMS_grade_id,'examId': (examsIds ? examsIds :[cmsExamIds[0]]),"studentId": localStorage.getItem('studentid')},_headers)
}
  isUserSubscribed(type:any,enrolledOrAttemptedTest:any, action='register'){
    // if(type?.toLowerCase().indexOf("schol") > -1) ret`urn Promise.resolve(false);
    this.attemptExamInfo = Array.isArray(enrolledOrAttemptedTest) ? enrolledOrAttemptedTest[0]:enrolledOrAttemptedTest
    if(!curTenantDetails['subscriptions']) return Promise.resolve(false);
      if(PaidSubscribedTest.indexOf(type.toUpperCase()) < 0 ) {
        return Promise.resolve(false);
      }
    var promise  = new Promise(async (resolve, reject) => {
    let isuserAdmin=  await isUserAdmin(this.userService)
       
    var user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    this.subscriptionData.userDetails = user;
    this.subscriptionData.userDetails.gradenumber = user?.grade?.name?.replace(/[^0-9]/g,'');
    console.log('this.subscriptionData.userDetails: ', this.subscriptionData.userDetails);
      this.spinner.show();
    if(this.getUSerExamlist){
      this.spinner.hide();
      if((timeBoundTypes.findIndex(v=>v?.toUpperCase() == type?.toUpperCase())) !=-1 &&  this.attemptExamInfo?.status?.toUpperCase()== "REGISTERED"){//for registered timebound allow exam
        resolve(false)
      }else {
        let openModal = !this.getUSerExamlist?.subscribeStatus && this.attemptExamInfo.exam_type =='3' && this.attemptExamInfo?.is_applicable? false: !this.getUSerExamlist?.subscribeStatus
        resolve(openModal)
      }
    }else{
      let body ={
        "studentId":  localStorage.getItem('studentid'),
        "testType": this.attemptExamInfo?.test_type
      }
      this.getNotCompletedTest(body).subscribe((resp:any)=>{
        this.getUSerExamlist = resp;
        this.spinner.hide();
        if((timeBoundTypes.findIndex(v=>v?.toUpperCase() == type?.toUpperCase())) !=-1 &&  this.attemptExamInfo?.status?.toUpperCase()== "REGISTERED"){//for registered timebound allow exam
          resolve(false)
        }else{
          let openModal = !this.getUSerExamlist?.subscribeStatus && this.attemptExamInfo.exam_type =='3' && this.getUSerExamlist?.is_applicable? false: !this.getUSerExamlist?.subscribeStatus
          resolve(openModal)
      }
        
      })
    }
    if(isuserAdmin){
        resolve(false)
       }
//Do not remove below commented code old Logic for subscription checking for particular exam
    // var allpromise = Promise.all([this.getFreeTrialDetails(),this.getSubscriptionDetails(),this.getExaminProgress(this.attemptExamInfo?.scheduleid, this.attemptExamInfo?._id)]).then((resp) => {
    //   console.log('resp: ', resp);
    //   this.examAttempedbysubId = resp?.[2]?.data;
    //   let targetexamName = localStorage.getItem('targetExamName')?.toLowerCase();
    //   if(( ['neet','jeemain','jeeadvanced','cbse','cuet'].indexOf(targetexamName) !==-1) &&  this.tenant.toLowerCase() == 'infinitylearn' && type?.toLowerCase() !== ('scholarshiptest')){
    //     let serverTime = localStorage.getItem('serverTime');
    //     var  numberofDays =  moment.unix(Number(serverTime)).diff(this.subscriptionData.userDetails?.createdTime, 'days');
    //     if(!numberofDays){
    //       numberofDays =  moment.unix(Number(serverTime)).isSame(this.subscriptionData.userDetails?.createdTime, 'days') ? 0 : 1;
    //     }
    //     var trialExamCounts = [];
    //     // ['TIMEBOUND','New NEET Mock Test','New NEET Timebound','MOCKTEST','RAPTimeBound','RAPDailyTest'].forEach((exam:any)=>{
    //     //   let filterExamType = this.apisData[apisDataCacheKeys.atemptedTests]?.filter((val)=>val?.examtype?.toLowerCase() ==  exam.toLowerCase() && val.coursetype?.trim()?.replace(' ',).toLowerCase() == targetexamName)
    //     //   if(filterExamType){
    //     //     trialExamCounts.push(...filterExamType)
    //     //   }
    //     // })
    //     const trialDays = this.subscriptionData?.trialData?.[0]?.days || 0;
    //     const maxAttempts = this.subscriptionData?.trialData?.find(v=>v?.title?.toUpperCase() == type.toUpperCase())?.maxAttempts || 0;
    //     var allActivePackages = this.allSubscribedActivePackages();
    //     let examTypeattempted = type;
    //     if(['TIMEBOUND','New NEET Mock Test','New NEET Timebound','MOCKTEST'].indexOf(type) !=-1){
    //       examTypeattempted =  type?.toLowerCase()?.indexOf('mock') !== -1? 'mock' : type?.toLowerCase()?.indexOf('timebound') !== -1 ? 'timebound' :'';
    //     }
    //      let checkAvaibbleComponentList = allActivePackages?.reduce((acc,v)=>{  acc.push(...v.componentsList);return acc},[])?.filter(v=>v?.name?.toLowerCase()?.indexOf(examTypeattempted?.toLowerCase()) !== -1 && v?.grade == this.subscriptionData.userDetails.gradenumber  )
    //     if (!allActivePackages?.length || !checkAvaibbleComponentList.length) {
    //         // section to check free  timebound registration and mocktest attempted in the previous history for free  starts//
    //         if(this.checkFreeTrialLimitExceeded(targetexamName,examTypeattempted,type)){
    //           this.spinner.hide();
    //           resolve( false);
    //         }else{
    //           this.spinner.hide();
    //           resolve(true)
    //         }
    //         // section to check  timebound registration  ends//
    //       }
    //       else if(this.checkFreeTrialLimitExceeded(targetexamName, examTypeattempted, type)){
    //      this.spinner.hide();
    //       resolve( false);
    //     }
    //    else if(allActivePackages?.length){
    //      let packageStatus  =[]
    //       var filterPackage = this.currentActivePackage(type);
    //       if(filterPackage && filterPackage?.userOrderPackageSubscriptionsDto){
    //       var ExamcountPermitted =  filterPackage?.componentsList?.find((val)=>val?.name?.toLowerCase()?.indexOf(examTypeattempted?.toLowerCase()) !== -1 && val?.grade == this.subscriptionData.userDetails.gradenumber )
    //       // var examtypeCount =  this.apisData[apisDataCacheKeys.atemptedTests]?.filter(val=>val?.examtype?.toLowerCase()?.indexOf(examTypeattempted?.toLowerCase()) !== -1)?.filter(val=>val?.coursetype?.trim()?.replace(' ','')?.toLowerCase() == localStorage.getItem('targetExamName')?.toLowerCase()) //can be un commented if needed
    //       var examtypeCount = this.UserAtttempted_inprogressExam(targetexamName, examTypeattempted, type)
    //     // var examtypeCount =  this.filterwithexamandCoursetype([... this.apisData[apisDataCacheKeys.atemptedTests]],examTypeattempted,localStorage.getItem('targetExamName')?.toLowerCase(),{testtype:this.attemptExamInfo?.test_type[0],exam_type:this.attemptExamInfo?.exam_type})
    //       // examtypeCount =  this.filterExamBasedonExamtype(localStorage.getItem('targetExamName')?.toLowerCase(),examtypeCount)
    //       examtypeCount  = examtypeCount?.filter(val=>val?.subscription?.id  ==  filterPackage?.subscription_id)??[];
    //       if(filterPackage?.isExpired){
    //         packageStatus.push(true)
    //       }
    //       else{
    //         if(!ExamcountPermitted) {
    //           if(numberofDays >= trialDays || trialExamCounts.length >= maxAttempts){
    //           packageStatus.push(true)
    //           }else{
    //           packageStatus.push(false)
    //           }
    //         }
    //         else if(examTypeattempted == 'mock'){
    //           if(ExamcountPermitted?.count < examtypeCount.length  || ExamcountPermitted?.count == examtypeCount.length  ){
    //           packageStatus.push(true)
    //           }
    //           else{
    //           packageStatus.push(false)
    //           }
    //         } else if(examTypeattempted == 'timebound'){
    //           if(ExamcountPermitted?.perMonthLimit){//true
    //             let serverTime = localStorage.getItem('serverTime');
    //           let thismonthattemptedILTSexam =  examtypeCount.filter((val)=>moment.unix(Number(serverTime)).isSame(new Date(val?.examsubmittedon),'month') && moment.unix(Number(serverTime)).isSame(new Date(val?.examsubmittedon),'year'))
    //                 if(thismonthattemptedILTSexam.length == ExamcountPermitted?.count || thismonthattemptedILTSexam.length > ExamcountPermitted?.count){
    //           packageStatus.push(true)
    //                 }else {
    //                 packageStatus.push(false)
    //                 }
    //           }else{//false
    //             // if(((ExamcountPermitted?.count < examtypeCount.length + maxAttempts)  || (ExamcountPermitted?.count == examtypeCount.length + maxAttempts)) ){
    //             if(((ExamcountPermitted?.count < examtypeCount.length )  || (ExamcountPermitted?.count == examtypeCount.length )) ){

    //               packageStatus.push(true)

    //             }
    //             else{
    //               packageStatus.push(false)

    //             }
    //           }
    //         } else {
    //           packageStatus.push(false)
    //         }
    //       }
    //     } else {// this block for existing packages
    //       if(this.checkFreeTrialLimitExceeded(targetexamName,examTypeattempted,type)){
    //         packageStatus.push( false);
    //       }else{
    //         packageStatus.push(true)
    //       }
    //     }
    //   this.spinner.hide();
    //   resolve(!packageStatus.some(v=> v == false))
    //   }
    //     else if(numberofDays >= trialDays || trialExamCounts.filter(v=>v.examtype == type )?.length >= maxAttempts){
    //   this.spinner.hide();
    //     resolve( true);
    //   }else{
    //   this.spinner.hide();
    //     resolve( false);
    //   }
    //   }
    //   else if(type?.toLowerCase() == ('scholarshiptest')){
    //     if(enrolledOrAttemptedTest && (enrolledOrAttemptedTest?.enrolled || enrolledOrAttemptedTest?.resume)){
    //       this.spinner.hide();
    //       resolve( false);
    //     }else{
    //       this.spinner.hide();
    //       resolve(true)
    //     }
    //     // this.scholarshipEnrollment(resolve,enrolledOrAttemptedTest)

    //   }
    //   else{
    //   this.spinner.hide();
    //     resolve( false);
    //   }
    // })
  })
  return promise
  }

  /* function return filtered array of exams based on schedule if jeeadvanced and rule id for others*/
  filterExamBasedonExamtype(ontargetExamName,attemptedExamSubscriptions,examtype?){
    if(ontargetExamName =='jeeadvanced'){
      let is_timeBound_test = (timeBoundTypes.indexOf(examtype) != -1) ? true : false;
       if(is_timeBound_test){
        attemptedExamSubscriptions = attemptedExamSubscriptions?.filter(v=> (v.isExamSubmittedByUser || v.isExamInProgress || v.enrolled || v.status == "COMPLETED"  ) && this.attemptExamInfo?.scheduleid !== v?.testformat_id)?.filter((v,i,s)=>s.findIndex(c=>c.testformat_id == v?.testformat_id) == i )
       }else{
         attemptedExamSubscriptions = attemptedExamSubscriptions?.filter(v=> (v.isExamSubmittedByUser || v.isExamInProgress || v.status == "COMPLETED"  ) && this.attemptExamInfo?.scheduleid !== v?.testformat_id)?.filter((v,i,s)=>s.findIndex(c=>c.testformat_id == v?.testformat_id) == i )
       }
    }
    return attemptedExamSubscriptions
  }

  getFreeTrialDetails(){
    var promise = new Promise((resolve,reject)=>{
      if(this.subscriptionData?.trialData){
        resolve(this.subscriptionData?.trialData);
        // this.spinner.hide();
      }else{
        this.trialData().subscribe((resp:any)=>{
          this.subscriptionData.trialData = resp;
          resolve(resp)
          // this.spinner.hide();
        },(err)=>{
          reject(err);
          // this.spinner.hide();
        })
      }
    })
    return promise;
  }
  getSubscriptionDetails(){
    var user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)):{};
    this.subscriptionData.userDetails = user;
    this.subscriptionData.userDetails.gradenumber = user?.grade?.name?.replace(/[^0-9]/g,'');
    var promise = new Promise((resolve,reject)=>{
      if(this.subscriptionData?.subscriptionsList){
        resolve(this.subscriptionData?.subscriptionsList)
      }else{
        this.getUserSubscription().subscribe((resp:any)=>{
          var  newResponse = [];
          resp?.forEach((val)=>{
            val.mySubcriptionDtoList.forEach(subv=>{
              let newObject  = {...subv}
              Object.keys(val).forEach(keys=>{
                newObject[keys] = val[keys]
              })
              newResponse.push(newObject)
            })
          })
          newResponse?.forEach((val)=>{
            this.subscriptionData.totalcomponentsList.push(...(val.componentsList||[]))
            if(val?.userOrderPackageSubscriptionsDto){ //check old method i.e no EMI option student
              let serverTime = localStorage.getItem('serverTime');
              let packageExpiry = moment.unix(Number(serverTime)).isAfter(val?.userOrderPackageSubscriptionsDto?.expiryDate)
              val.isExpired = [val?.userOrderPackageSubscriptionsDto.expired, packageExpiry].some(v=>v == true)
            }
            else{
              val.isExpired  =moment().isAfter(val?.userOrderPackageSubscriptionsDto?.expiryDate);
            }
            val.subscription_id  = val?.userOrderPackageSubscriptionsDto?.id;
          })
          this.subscriptionData.subscriptionsList = newResponse.sort((a,b)=>b?.subscription_id-a.subscription_id);
          resolve(resp)
        },(err)=>{
          reject(err)
        })
      }
    })
    return promise;
  }

  currentActivePackage(type?) {
    let ontargetExamName = localStorage.getItem('targetExamName')?.toLowerCase()
    let examTypeattempted = type;
    if(['TIMEBOUND','New NEET Mock Test','New NEET Timebound','MOCKTEST'].indexOf(type) !=-1){
      examTypeattempted =  type?.toLowerCase()?.indexOf('mock') !== -1? 'mock' : type?.toLowerCase()?.indexOf('timebound') !== -1 ? 'timebound' :'';
    }
    // /* Below we are checking number of  Exams attempeted as per subscription id*/
    // let attemptedExamSubscriptions = this.apisData[apisDataCacheKeys.atemptedTests]
    // ?.filter(v => v?.coursetype?.trim()?.replace(' ','')?.toLowerCase() == ontargetExamName)
    // ?.filter(val => val?.examtype?.toLowerCase()?.indexOf(examTypeattempted?.toLowerCase()) !== -1)

    /** Below we are checking are the purchased subscription and  free test examtype count matching */
    if (!this.subscriptionData?.subscriptionsList) {
      this.spinner.show()
      this.getStudentExamResult().subscribe(() => {
        Promise.all([this.getFreeTrialDetails(), this.getSubscriptionDetails()]).then((resp) => {
          this.spinner.hide()
          this.currentActivePackage(type)
        })
      })
    } else{
      let attemptedExamSubscriptions= this.UserAtttempted_inprogressExam(ontargetExamName,examTypeattempted,type)
      // attemptedExamSubscriptions = this.filterExamBasedonExamtype(ontargetExamName,attemptedExamSubscriptions);
      attemptedExamSubscriptions = attemptedExamSubscriptions?.map(v => v?.subscription?.id)
        ?.reduce((acc, subid) => {
          let sub_index = acc.findIndex(v => v.subscription_id == subid)
          if (sub_index !== -1) {
            acc[sub_index].test_attempted = acc[sub_index].test_attempted + 1;
          } else {
            acc.push({
              subscription_id: subid,
              test_attempted: 1
            })
          }
          return acc
        }, [])
      let mxattepmtsForexamType = this.subscriptionData?.trialData?.find(v => v?.title?.toUpperCase() == type?.toUpperCase())?.maxAttempts;
      // if(this.checkFreeTrialLimitExceeded(ontargetExamName,examTypeattempted,type)){ commented  for now
      if(!attemptedExamSubscriptions?.length || attemptedExamSubscriptions.find((v: any) => v?.subscription_id == 0 && v.test_attempted  < mxattepmtsForexamType)){
        return{}
      }
      var subscriptionListCpunt = this.subscriptionData?.subscriptionsList
        .filter(v => !v.isExpired).map(element => {
          var alreadyattemped = attemptedExamSubscriptions?.find(v => v?.subscription_id == element?.userOrderPackageSubscriptionsDto?.id)
          if (!alreadyattemped) {
            element.examcountexceeded = false;
          } else {
            var componentexam = element.componentsList.find(v => v.name.toLowerCase().indexOf(examTypeattempted.toLowerCase()) != -1)
            if (componentexam && componentexam?.count) {
              element.examcountexceeded = (alreadyattemped.test_attempted > componentexam.count || componentexam.count == alreadyattemped.test_attempted) ? true : false;
            } else {
              element.examcountexceeded = true;
            }
          }
          return element
        });
      /** Below we are checking are the examcountexceeded and returning most active subscription whose limit is not reached */
      if (this.subscriptionData.totalcomponentsList?.length) {
        var examNamefilterKey = localStorage.getItem('targetExamName')?.toLowerCase();
        if (examNamefilterKey == 'jeemain' && this.subscriptionData?.subscriptionsList.filter(v => v.packagesDto?.description.toLowerCase().indexOf('jeeadvanced') != -1 && !v.isExpired && v.targetExam.indexOf('JEE') != -1)?.length) {
          examNamefilterKey = 'jeeadvanced';
        }
        return subscriptionListCpunt
          ?.filter(v => !v.examcountexceeded && (v?.componentsList.find(v => v.name.toLowerCase().indexOf(examTypeattempted?.toLowerCase()) != -1 && v?.grade ==  this.subscriptionData.userDetails?.gradenumber))).find((val: any) => val.exams.toLowerCase().indexOf(examNamefilterKey) != -1)
      } else {
        return {}
      }
    }
  }
   /*Filtering already attempted  test free
    return true if free test  not attempted and viceversa */
  checkFreeTrialLimitExceeded(ontargetExamName, examTypeattempted, type) {
  let attemptedExamSubscriptions =  this.UserAtttempted_inprogressExam(ontargetExamName, examTypeattempted, type)
  let maxAttempts =  this.subscriptionData?.trialData?.find(v => v?.title?.toUpperCase() == type?.toUpperCase())?.maxAttempts;
    if (maxAttempts && (!attemptedExamSubscriptions?.length || attemptedExamSubscriptions.filter((v: any) => v?.subscription?.id == 0).length <  maxAttempts)) {
      return true
    } else {
      return false;
    }
  }
  UserAtttempted_inprogressExam(ontargetExamName, examTypeattempted, type){
    let is_timeBound_test = (timeBoundTypes.indexOf(type) != -1) ? true : false;
    let examinResumeSubscriptions=[]
    if(this.apisData[apisDataCacheKeys?.allTests]){
    examinResumeSubscriptions = this.apisData[apisDataCacheKeys?.allTests]?.filter(v=> {
      let daysdiff = moment(v?.span, "YYYY-MM-DD hh:mm A").diff(moment(), 'days')
      return v?.isExamInProgress || (is_timeBound_test && v?.enrolled && v?.scheduleid != this.attemptExamInfo?.scheduleid && (daysdiff > 0 || daysdiff == 0))
    })?.map((v=>{
      let findsubId = this.examAttempedbysubId?.find(invv => invv?.ruleid == v?._id);
      v.subscription = findsubId ? findsubId.subscription?.[0] : { module: 'assessment', id: 0 }
      return v
    }))
    }else{
      return examinResumeSubscriptions= []
    }
    let attemptedExamSubscriptions = [...this.apisData[apisDataCacheKeys?.atemptedTests]]?.concat(examinResumeSubscriptions);
    if(!this.attemptExamInfo?.test_type?.[0]){
      this.attemptExamInfo  = this.storage.retrieve('examinfo');;
    }
    attemptedExamSubscriptions = this.filterwithexamandCoursetype([...attemptedExamSubscriptions],examTypeattempted,ontargetExamName,{testtype:this.attemptExamInfo?.test_type[0],exam_type:this.attemptExamInfo?.exam_type})
      attemptedExamSubscriptions =  this.filterExamBasedonExamtype(ontargetExamName,attemptedExamSubscriptions,type);
      // if(type){//this line will filter NEW NEET MOCKTEST or SCOREMOCKTES commenting for now
      //   attemptedExamSubscriptions = attemptedExamSubscriptions?.filter(v=>v.examtype?.toLowerCase() == type?.toLowerCase())
      // }
      return attemptedExamSubscriptions;
  }
  filterwithexamandCoursetype(arr,examTypeattempted,ontargetExamName,examDetail){
  //   console.log(arr?.filter(v => v?.coursetype?.trim()?.replace(' ','')?.toLowerCase() == ontargetExamName));
  //   return arr?.filter(v => v?.coursetype?.trim()?.replace(' ','')?.toLowerCase() == ontargetExamName)
  //   ?.filter(val => val?.examtype?.toLowerCase()?.indexOf(examTypeattempted?.toLowerCase()) !== -1)
    return arr.filter(v=>v?.exam_type == examDetail?.exam_type && (v?.test_type ?v?.test_type?.indexOf(examDetail?.testtype) !=-1 : v?.TestType == examDetail?.testtype))
  }
  checkResumeNowandFreePaper(targetexamName,type){
    const examname = getExamName(type);
    type = (examname == '') ? type : examname;
    let freemaxAttempts = this.subscriptionData?.trialData?.find(v => v?.title?.toUpperCase() == type.toUpperCase())?.maxAttempts;//free avaible attempts
    let Examfilter_basedon_type = this.apisData.all_exams_details_from_server.filter((v) =>v.coursetype?.trim()?.replace(' ','')?.toLowerCase() == targetexamName && v?.examtype == type);
    Examfilter_basedon_type =  this.filterExamBasedonExamtype(targetexamName,Examfilter_basedon_type,type)
     //filter for type of exam and coursetype attempted
    var freenrolled_exams = []
    if (timeBoundTypes.indexOf(type) != -1) {
      freenrolled_exams = Examfilter_basedon_type.filter((v) => {//filter coming days or same day and  for only enrolled change
        let daysdiff = moment(v?.span, "YYYY-MM-DD hh:mm A").diff(moment(), 'days')
        return v.enrolled && (daysdiff > 0 || daysdiff == 0)
      })
    } else if (nonTimeBoundTypes.indexOf(type) != -1) {
      freenrolled_exams = Examfilter_basedon_type.filter(v=>v?.resume || v?.testtaken || v?.isExamInProgress)
    }
    if ((freenrolled_exams?.length == freemaxAttempts || freenrolled_exams?.length > freemaxAttempts)) {// free attempts who has no active package
        return true
      }
  }

  trialData(){
    return this.get(this.omsdevapi + 'targetexams/freeTrailLimit')
  }
  getUserSubscription(){
    var grade  = this.subscriptionData?.userDetails?.grade?.name?.split('th')?.[0]?.toString()
    grade = grade?.replace(/[^0-9]/g, '');
    // return this.get(this.omsdevapi + 'userorders/'+this.subscriptionData?.userDetails?.userId+'?grade='+grade)
    return this.get(this.omsdevapi + 'userorders/mySubscription?userId='+this.subscriptionData?.userDetails?.userId+'&grade='+grade)

  }


  getCurrentServerTime(){
    let params = {
      type: 'recommended',
      page: 1,
      limit: 2,
      customFilter: ''
    };
    return this.classService.getClasses(params).subscribe((res: any) => {
      if (res && res.statusCode == 200) {
        localStorage.setItem('serverTime', res.data.utcTime)
      }
    });
  }
  getServerTime() {
    var promise = new Promise((resolve, rej) => {
      let params = {
        type: 'recommended',
        page: 1,
        limit: 2,
        customFilter: ''
      };
      this.classService.getClasses(params).subscribe((res: any) => {
        if (res && res.statusCode == 200) {
          localStorage.setItem('serverTime', res.data.utcTime)
          resolve(res.data.utcTime)
        }
      }, (err) => {
        rej(false)
      });
    });
    return promise;
  }

  getSchedulesData(ruleIds) {
    const tenant : any = TenantConstant.tenant;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(this.newApiUrl + `rules/syllabus`, ruleIds, headers);
  }

  getTestSyllebus(ruleId:any): Observable<any> {
    const url = this.newApiUrl + `rules/syllabus/${ruleId}`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getWithHeaders<any>(url, _headers);
  }

  getUpcomingTest(data: any): Observable<any> { 
  // let newBody=  {
  //     "studentId": data?.studentid,
  //     "gradeId": data?.classes,
  //     "examId": [
  //       data.exam_type
  //     ]
  //   }

    const url = this.newApiUrl + `exam/freeExam`;
    // const url = this.newApiUrl + `exam/getUpcomingTests`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, data, _headers).pipe(share(),map(data=>data))

  }
  getUpcomingTestV2(data: any): Observable<any> { 
  let newBody=  {
      "studentId": data?.studentid,
      "gradeId": data?.classes,
      "examId": [
        data.exam_type
      ]
    }
    const url = this.newApiUrl + `exam/getUpcomingTests`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, newBody, _headers).pipe(share(),map(data=>data?.upcomingTests))

  }
  getTestCards(): Observable<any> {
    const url = this.newApiUrl + `exam/cards`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getWithHeaders<any>(url, _headers);
  }

  getExamQuestion(payload: any): Observable<any> {
    const url_ = this.apiUrl + 'exam/questions';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };

    return this.getByHeaders<any>(url_, payload, headers);
  }
  getchaptersforsubjects(payload, examId: any, userId: any){
    const url_ = this.cmsapiUrl + 'examtoc/getChaptersForExamSubjectGrades/' + examId;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN',
      'userId': userId + ""
    };
     return this.getByHeaders<any>(url_, payload,headers);
  }
  testReportV2(payload: any): Observable<any> {
    const url_ = (payload?.ruleid).indexOf('paper') !=-1 ?this.newApiUrl + 'reports/testrecord':this.newApiUrl + 'reports/testrecord/JeeAdvanced';    
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getByHeaders<any>(url_, payload, headers);
  }
  getBoardRanges(): Observable<any> {
    const url_ = this.newApiUrl + 'reports/v2/reportTemplates';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getWithHeaders<any>(url_, headers);
  }
  getQuestionsForAssignment(payload: any): Observable<any> {
    const url_ = this.newApiUrl + 'exam/questions';    
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getByHeaders<any>(url_, payload, headers);
  }
  examcyot(payload: any): Observable<any> {
    const url_ = this.cyotUrl + 'generatequestions/cyot';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getByHeaders<any>(url_, payload, headers);
  }
  confirmcyot(body){
    const url_ = this.cyotUrl + 'generatequestions/confirmcyot';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getByHeaders(url_,body,headers);
  }
  examcyotduplicate(payload: any): Observable<any> {
    const url_ = this.apiUrl + 'cyot/student';
    const tenant : any = TenantConstant.tenant;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN',
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url_, payload, headers);
  }
  getCyotExams(): Observable<any> {
    const url_ = this.apiUrl + 'cyot/getCyotExams';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.getWithHeadersAndParams<any>(url_,headers,{userid: this.subscriptionData.userDetails?.userId,grade:this.subscriptionData.userDetails.grade?.name});
  }
  allSubscribedActivePackages(){
    if(this.subscriptionData.totalcomponentsList?.length){
      var examNamefilterKey = localStorage.getItem('targetExamName')?.toLowerCase();
      if(examNamefilterKey == 'jeemain' && this.subscriptionData?.subscriptionsList.filter(v=>v.packagesDto?.description.toLowerCase().indexOf('jeeadvanced') != -1 && !v.isExpired && v.targetExam.indexOf('JEE') != -1)?.length ){
        examNamefilterKey = 'jeeadvanced';
      }
    return this.subscriptionData?.subscriptionsList?.filter((val:any)=>( (val.exams.toLowerCase().indexOf(examNamefilterKey) != -1 )&& !val.isExpired)).filter(v=>v)
  }
  }
  getExaminProgress(scheduleId, ruleid){
    const url_ = this.apiUrl + 'exam/getSubscriptionData';
       let headers = {
         'accesstoken': localStorage.getItem('token'),
         'Content-Type': 'application/json',
         'X-Content-Type-Options': 'nosniff',
        }
       return this.getByHeaders<any>(url_, {studentid: localStorage.getItem('studentid'), ruleid: ruleid, scheduleid: scheduleId}, headers).toPromise()
  }
  ScoreScheduleListDetails(){
    // let selectedExam =this.subscriptionData.userDetails.exams.find(v=>v.name == examDisplayNames[localStorage.getItem('targetExamName')])   ;
    // let gradeId = this.subscriptionData?.userDetails?.grade?.gradeId
    // let courseId =  getCourseId(localStorage.getItem('targetExamName'))
    let getCMSdata = this.filterCMSData()
    let body=  {
        "examtype": getCMSdata?.[0]?.CMS_Exam_id,
        "userid": String(this.subscriptionData.userDetails?.userId),
        "grade":   getCMSdata?.[0]?.CMS_grade_id,
        "studentid":  this.subscriptionData.userDetails?.phone
      }
    const url_ = this.apiUrl + 'score/getStudentScoreExam';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
     }
    return this.getByHeaders<any>(url_,body, headers)
  }
  knowYourTest(body){
    const url_ = this.apiUrl + 'score/knowYourTest';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
     }
    return this.getByHeaders<any>(url_,body, headers)
  }
  getTotalRegistrationRegistration(body){
    const url_ = this.apiUrl + 'score/getTotalRegistration';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
     }
    return this.getByHeaders<any>(url_,body, headers)
  }
  setScoreReminder(body){
    const url_ = this.apiUrl + 'score/setReminderForSCORE';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
     }
    return this.getByHeaders<any>(url_,body, headers)
  }

  setScoreReminderBefore15m(body){
    const url_ =  this.uamApiUrl+'/sms/testreminder';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
     }
    return this.getByHeaders<any>(url_,body, headers)
  }
  getUserDetails(body){
    return   this.getByHeaders(this.uamApiUrl+'/api/users/getUserDataByPhoneOrEmail',body,{
        "appKey":"AB263AFA6BCFA",
         "appSecret":"00nqBP1LsQpZMMnMApSjfjd2DVRkEnlp"
      }
    )
  }
  scoreTestReport(payload: any): Observable<any> {
    const url_ = this.newApiUrl + 'reports/testrecord';
    return this.getByHeaders<any>(url_, payload,{});
  }
  getEntityScoreTestDateTimeOnline(): Observable<any> {
    let payload = {entity:"INFINITYLEARN"}
    const url_ = this.stageeosapi + 'getDateTimeOnline';
    return this.getWithHeadersAndParams<any>(url_, {},payload);
  }
  getSubscriptionCount(payload){
    const url_ = this.stageeosapi + 'getSubscriptionCount';
    return this.getWithHeadersAndParams<any>(url_, {},payload);
  }
  EnrollToScore(body){
    const url_ = this.stageeosapi + 'registerStudent';
    return this.getByHeaders<any>(url_,body,{});
  }
  getNotCompletedTest(body) {
    const url = this.apiUrl + `exam/getCardTests`;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    body.gradeId = cmsDetails?.[0]?.CMS_grade_id;
    body.examId = [cmsExamIds[0]];
    return this.getByHeaders<any>(url, body, _headers);
  }
  getMySubscriptionWithFreeCount(){
    const url = this.apiUrl + `exam/getMySubscriptionWithFreeCount`;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    this.getWithHeadersAndParams(url,_headers,{
      userId:this.subscriptionData.userDetails?.userId,
      gradeId:this.subscriptionData.userDetails?.gradenumber
    }).subscribe((resp) => {
      console.log("🚀 ~ file: testlist.service.ts:1802 ~ getMySubscriptionWithFreeCount ~ resp", resp)
    })
  }
  getReportTemplate(){
    let examType = this.storage.retrieve('examinfo')?.exam_type
    // let url = '';
    // if(examType === '3'){
    //    url =this.apiUrl+'reports/v2/reportTemplates';
    // }else{
    // }
    let url =this.apiUrl+'reports/v2/reportTemplates';
  const _headers = {
    'accesstoken': localStorage.getItem('token'),
  };
    return this.getWithHeaders(url,_headers)
  }
  
  getStudentRecords(params){
    let url = this.stageeosapi + 'getStudentRecords'
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getWithHeadersAndParams(url,_headers,params)
  }


  getScoreSyllabus(params){
    let url = this.stageeosapi + 'gradeSyllabusDataV1'
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getWithHeadersAndParams(url,_headers,params)
  }
  
  scoreExamDataV1(param){
    let url = this.stageeosapi + 'scoreExamDataV1'
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getWithHeadersAndParams(url,_headers,param)
  }


  getTokenAPI(body:any): Observable<any> {
    const url = this.LEARN_BE_EVENT_API + `token/user/getToken`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, body, _headers);
  }
  
  getPeakMindStatus(grade:any, exam:any, token:any): Observable<any> {
    const url = this.LEARN_BE_EVENT_API + `peakmind/lsq/usereventspeakmind/status?grade=${grade}&exam=${exam}&userToken=${token}`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getWithHeaders<any>(url, _headers);
  }

  putPeakMindStatus(grade:any, exam:any, token:any): Observable<any> {
    const url = this.LEARN_BE_EVENT_API + `peakmind/lsq/usereventspeakmind/status?grade=${grade}&exam=${exam}&userToken=${token}`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.put<any>(url, {}, _headers);
  }
 
}